<template>
  <section class="step4">
    <div class="col-sm-12" id="step4">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <h5>{{ __('message_interface.step4.your_msg') }}</h5>
          <div
            v-if="message.type === 'email'"
            class="card card-primary card-outline direct-chat direct-chat-primary shadow-none"
          >
            <div class="card-header">
              <h3 class="card-title">{{ message.messageSubject ?? 'Sans objet' }}</h3>
            </div>
            <div class="card-body">
              <div class="direct-chat-messages">
                <div class="direct-chat-msg">
                  <iframe
                    v-if="message.type == 'email'"
                    :srcdoc="message.messageToSend.replaceAll(/<mark\b[^>]*>/gi, '')"
                    frameborder="0"
                    width="100%"
                    height="550px"
                  >
                  </iframe>
                </div>
              </div>
            </div>
          </div>
          <PhoneComponent
            v-if="message.type === 'sms'"
            :message="message.messageToSend"
            style="margin: 0"
          />
        </div>
        <div class="col-md-4">
          <div v-if="message.type === 'email'" class="mt-4">
            <label class="typo__label">{{
              __('message_interface.step4.send_me_copy.title')
            }}</label>
            <div class="d-flex mb-2">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="set_cc"
                  id="customRadioInline1"
                  name="customRadioInline"
                  v-model="message.options.email"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="customRadioInline1">
                  {{ __('message_interface.step4.send_me_copy.cc') }}
                </label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  id="customRadioInline2"
                  name="customRadioInline"
                  value="set_cci"
                  v-model="message.options.email"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="customRadioInline2">
                  {{ __('message_interface.step4.send_me_copy.cci') }}
                </label>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <label class="typo__label">{{ __('message_interface.step4.choose_receiver') }}</label>
            <Multiselect
              :placeholder="__('message_interface.step4.type_cutomer_number')"
              label="first_name"
              :custom-label="clientCustomLabel"
              track-by="first_name"
              :options="clients"
              ref="getclients"
              @search-change="showValue"
              v-model="message.selectedClient"
            >
              <template #noResult>
                {{ __('message_interface.step4.no_result') }}
                <a @click="addNewClientToSend" class="text-underline">
                  {{ __('message_interface.step4.add_new_contact') }}
                </a>
              </template>
            </Multiselect>
          </div>
          <div v-if="addNewClient">
            <MessageNewClientForm
              :type="message.type"
              @created="selectNewClientContact"
              @cancel="cancelAddNewClientContact"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <button
        type="button "
        :disabled="message.loading"
        @click="$emit('prev-tab')"
        class="btn btn-primary"
      >
        {{ __('message_interface.btns.prev') }}
      </button>
      <button
        class="btn btn-primary float-right"
        @click="submitSendMessage"
        :disabled="message.selectedClient === null || message.loading"
      >
        <i v-if="message.loading" class="fa-regular fa-spinner fa-spin-pulse fa-sm mr-2"></i>
        <span>{{ __('message_interface.btns.submit') }}</span>
      </button>
    </div>
    <div class="clearfix"></div>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import PhoneComponent from './PhoneComponent.vue'
import MessageNewClientForm from './MessageNewClientForm.vue'

export default {
  name: 'MessageSelectClient',
  props: ['message', 'clients'],
  components: {
    Multiselect,
    PhoneComponent,
    MessageNewClientForm
  },
  data() {
    return {
      addNewClient: false,
      client: {}
    }
  },
  methods: {
    addNewClientToSend() {
      this.addNewClient = true
    },
    selectNewClientContact() {
      this.message.selectedClient = this.clients[this.clients.length - 1]
      this.addNewClient = false
    },
    submitSendMessage() {
      this.$emit('submitSendMessage', this.message)
    },
    cancelAddNewClientContact() {
      this.addNewClient = false
      this.client = {}
    },
    showValue(e) {
      if (this.message.type === 'sms') {
        this.client.phone = e
      }
      if (this.message.type === 'email') {
        this.client.email = e
      }
    },
    clientCustomLabel({ first_name, last_name, email, phone }) {
      if (this.message.type === 'sms') {
        return `${first_name} ${last_name} (${phone}) `
      }
      if (this.message.type === 'email') {
        return `${first_name} ${last_name} (${email}) `
      }
    }
  }
}
</script>
